import { IOnCampusServiceStatisticsRequest } from 'types/DashboardType'
import http from '../core/http-common'
import { IMyPlan } from '../types/PlanType'

class PlanService {
  GetMyPlanList(startDate: string, endDate: string) {
    return http.get<IMyPlan[]>(`/Plan/GetMyPlanList?startDate=${startDate}&endDate=${endDate}`)
  }

  getCampusServiceStatsSummary(data: IOnCampusServiceStatisticsRequest) {
    return http.post(`/Plan/GetCampusServiceStatistics`, data)
  }
}

export default new PlanService()
